import { render, staticRenderFns } from "./Patient.vue?vue&type=template&id=ea4c215c&scoped=true&"
import script from "./Patient.vue?vue&type=script&lang=js&"
export * from "./Patient.vue?vue&type=script&lang=js&"
import style0 from "./Patient.vue?vue&type=style&index=0&id=ea4c215c&prod&lang=scss&scoped=true&"
import style1 from "./Patient.vue?vue&type=style&index=1&id=ea4c215c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4c215c",
  null
  
)

export default component.exports